import { Fragment } from "react";
import Box from "@mui/material/Box";
import Link from "next/link";

import { useI18n } from "@/i18n/I18nProvider";

import { ICONS, MAIN_MENU_LINKS } from "../navbar.config";
import { menuLink, menuSeparator } from "../navbar.styles";
import MenuCard from "./MenuCard";

/* The corporate menu behind the hamburger in the desktop top bar. */
export default function MainMenu({ onNavigate }) {
  const { t, locale } = useI18n();

  return (
    <MenuCard width="250px">
      <Box
        sx={{
          p: 2,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {MAIN_MENU_LINKS.map(({ id, href, label }, index) => (
          <Fragment key={id}>
            {index > 0 && <Box sx={menuSeparator} />}

            <Box
              component={Link}
              href={href(locale)}
              onClick={onNavigate}
              sx={menuLink}
            >
              {label(t)}

              {/* Points the way the language reads. */}
              <Box
                component="img"
                src={ICONS.menuArrow(locale)}
                alt=""
                aria-hidden="true"
                sx={{ width: "30px" }}
              />
            </Box>
          </Fragment>
        ))}
      </Box>
    </MenuCard>
  );
}
